import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars

export default {
  methods: {
    paginationChange(payload) {
      this[payload.sublistName] = payload.list;
    }
  },
};
